import {
  CardContent,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import { makeStyles } from '@mui/styles';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { format } from "date-fns";
import { useState } from "react";
import { useHistory } from "react-router";

const useStyles = makeStyles(() => ({
  card: {
    maxWidth: 390,
    margin: "auto",
  },
  media: {
    height: 300,
    paddingTop: "56.25%", // 16:9
  },
  avatar: {
    marginLeft: "4px",
    marginRight: "12px",
  },
  score: {
    textAlign: "center",
    fontSize: "10px",
  },
  actions: {
    marginRight: "-2px",
  },
  headerTitle: {
    height: 38,
    display: "flex",
  },
  root: {
    padding: "12px 4px 8px 4px",
  },
}));

const Note = ({ note, onRemove }) => {
  const classes = useStyles();
  const history = useHistory();
  const [menuEl, setMenuEl] = useState(null);
  const isMenuOpen = Boolean(menuEl);

  const openMenu = (event) => {
    setMenuEl(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuEl(null);
  };

  return (
    <>
      <Card className={classes.card}>
        <CardHeader
          avatar={
            <div className={classes.score}>
              Score
              <Avatar>{note.score}</Avatar>
            </div>
          }
          action={
            <IconButton
              aria-label="note-actions"
              onClick={openMenu}
            >
              <MoreVertIcon />
            </IconButton>
          }
          title={note.name}
          subheader={
            <p
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "4px 0 0 0",
              }}
            >
              <span>{`${note.abv} %`}</span>
              <span>{`Age: ${note.age}`}</span>
            </p>
          }
          classes={{
            title: classes.headerTitle,
            root: classes.root,
            avatar: classes.avatar,
            action: classes.actions
          }}
        />
        <CardMedia
          className={classes.media}
          image={
            note.image
              ? note.image
              : "https://images.unsplash.com/photo-1581431886281-93ae50c19271?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1050&q=80"
          }
          title={note.name}
        />
        <CardContent>
          <Typography variant="body2">
            {`Created: ${format(
              new Date(note.created),
              "dd.MM.yyyy 'at' HH:mm"
            )}`}
          </Typography>
          <Typography variant="body2">
            {`Modified: ${
              note.modified
                ? format(new Date(note.modified), "dd.MM.yyyy 'at' HH:mm")
                : "-"
            }`}
          </Typography>
        </CardContent>
      </Card>
      <Menu
        id="note-menu"
        anchorEl={menuEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        keepMounted
        style={{ marginTop: "40px" }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={isMenuOpen}
        onClose={closeMenu}
      >
        <MenuItem
          onClick={() => {
            closeMenu();
            history.push(`/note/${note.id}`);
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            closeMenu();
            onRemove(note.id);
          }}
        >
          Remove
        </MenuItem>
      </Menu>
    </>
  );
};

export default Note;
